import { render, staticRenderFns } from "./TimeOff.vue?vue&type=template&id=70a5fa53&scoped=true"
import script from "./TimeOff.vue?vue&type=script&lang=js"
export * from "./TimeOff.vue?vue&type=script&lang=js"
import style0 from "./TimeOff.vue?vue&type=style&index=0&id=70a5fa53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5fa53",
  null
  
)

export default component.exports